export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-vidicon-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-bold text-background-50 whitespace-nowrap">吃瓜视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              聚焦国产吃瓜视频，涵盖国内最新热点事件、综艺片段与影视解说，在线免费观看国产热门内容。做最懂你的娱乐资讯平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热门内容</a>
              <a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">最新快讯</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热门话题</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热度榜单</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#media" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">视频精选</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">专题合集</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a>
              <a href="#comments" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">用户热评</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              更多合作伙伴信息敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 吃瓜视频 - 国产吃瓜视频在线平台。本站内容仅供娱乐参考。
          </p>
          <div className="flex items-center gap-5">
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">服务条款</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">内容声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}